"use strict";

/* global dataLayer */

import Toolbox from "./toolbox";

function clickEventAnalytics(text) {

	dataLayer.push({
		event: "GAEvent",
		eventCategory: "Navigation - Horizontal scrolling menu",
		eventAction: "click",
		eventLabel: "page:" + document.title + " link:" + text
	});

}

function scrollEventAnalytics() {
	dataLayer.push({
		event: "GAEvent",
		eventCategory: "Navigation - Horizontal scrolling menu",
		eventAction: "scroll",
		eventLabel: "page:" + document.title
	});

}


function scrollHandler(e) {
	Toolbox.waitForFinalEvent(() => {
		scrollEventAnalytics();
	}, 50, "sideScrollNavAnalytics");

}

export default () => {
	const categorySliders = document.querySelectorAll(".category-slider");

	window.addEventListener("pageshow", (event) => {
		if (event.persisted) {
			const hiddenItems = document.querySelectorAll("[data-category-slider-hidden], .product-list-actions, #o-product-listing .load-more-results");
			for (const hiddenItem of hiddenItems) {
				hiddenItem.style.display = "";
				delete hiddenItem.dataset.categorySliderHidden;

				if (hiddenItem.classList.contains("product-list-actions")) {
					hiddenItem.classList.remove("loading");
					if (hiddenItem.dataset.hadDone) {
						delete hiddenItem.dataset.hadDone;
						hiddenItem.classList.add("done");
					} else {
						hiddenItem.classList.remove("done");
					}
				}

				if (hiddenItem.classList.contains("load-more-results")) {
					hiddenItem.classList.remove("loading");
					for (const el of hiddenItem.querySelectorAll("p, a")) {
						el.style.display = "";
					}

					if (hiddenItem.dataset.addedMoreResults) {
						hiddenItem.classList.remove("has-more-results");
						delete hiddenItem.dataset.addedMoreResults;
					}
				}
			}
		}
	});


	for (const categorySlider of categorySliders) {

		const slider = categorySlider.querySelector("ul");

		if (slider) {

			if (dataLayer) {
				slider.addEventListener("scroll", scrollHandler, { passive: true });
			}

			const activeItem = slider.querySelector(".active");

			if (activeItem) {
				slider.scrollTo({ left: activeItem.offsetLeft });
			}
			categorySlider.classList.remove("loading");

			categorySlider.addEventListener("click", (e) => {
				const target = e.target;

				if (target.tagName === "A" && target.href) {
					if (dataLayer) {
						slider.removeEventListener("scroll", scrollHandler, { passive: true });
						clickEventAnalytics(target.textContent);
					}

					const scrollPosition = target.offsetLeft;

					const activeLink = categorySlider.querySelector(".active");

					if (activeLink) {
						activeLink.classList.remove("active");
					}

					slider.scrollTo({ left: scrollPosition, behavior: "smooth" });
					target.classList.add("active");

					const hideItems = document.querySelectorAll(".product-list, .filter-bar, .product-list-grid, #o-product-listing .search-results-top-content");
					for (const hideItem of hideItems) {
						hideItem.style.display = "none";
						hideItem.dataset.categorySliderHidden = true;
					}

					const productListActions = document.querySelector(".product-list-actions, #o-product-listing .load-more-results");
					if (productListActions) {

						if (productListActions.classList.contains("load-more-results")) {
							productListActions.classList.add("loading");

							for (const el of productListActions.querySelectorAll("p, a")) {
								el.style.display = "none";
								el.dataset.categorySliderHidden = true;
							}

							if (!productListActions.classList.contains("has-more-results")) {
								productListActions.classList.add("has-more-results");
								productListActions.dataset.addedMoreResults = true;
							}

						} else {
							productListActions.classList.add("loading");
							productListActions.classList.remove("done");
							productListActions.dataset.categorySliderHidden = true;
							if (productListActions.classList.contains("done")) {
								productListActions.dataset.hadDone = true;
							}
						}
					}

				}

			});
		}
	}

};
